import Tag from '@/shared/models/Tag';

export interface JobId {__jobId: number;}

export interface JobDescription {
  content: string;
  editable: boolean;
}

export default abstract class AbstractJob {
  id!: JobId;
  description: JobDescription = {
    content: '',
    editable: true,
  };

  imageCount = 0;
  videoCount = 0;
  attachmentCount = 0;
  diagnosticCount = 0;
  tags: Array<Tag> = [];
  sequenceNumber = 0;
}
